import { render, staticRenderFns } from "./Equipments.vue?vue&type=template&id=35abe7d0&scoped=true"
import script from "./Equipments.vue?vue&type=script&lang=js"
export * from "./Equipments.vue?vue&type=script&lang=js"
import style0 from "./Equipments.vue?vue&type=style&index=0&id=35abe7d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abe7d0",
  null
  
)

export default component.exports